<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <div class="container-fluid content-type-20">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                        <div class="content">
                            <h1 class="h2">{{ $t('views.onboarding.welcome') }}</h1>
                            <p class="p">{{ $t('views.onboarding.description') }}</p>
                            <ol class="list-ordered">
                                <li>
                                    <div class="icon-search-pos"></div>
                                    <div class="content">
                                        <p class="title">{{ $t('views.onboarding.steps.search.title') }}</p>
                                        <p class="description">{{ $t('views.onboarding.steps.search.description') }}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon-target-pos"></div>
                                    <div class="content">
                                        <p class="title">{{ $t('views.onboarding.steps.qualify.title') }}</p>
                                        <p class="description">{{ $t('views.onboarding.steps.qualify.description') }}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon-account-pos"></div>
                                    <div class="content">
                                        <p class="title">{{ $t('views.onboarding.steps.contact.title') }}</p>
                                        <p class="description">{{ $t('views.onboarding.steps.contact.description') }}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon-database-pos"></div>
                                    <div class="content">
                                        <p class="title">{{ $t('views.onboarding.steps.export.title') }}</p>
                                        <p class="description">{{ $t('views.onboarding.steps.export.description') }}</p>
                                    </div>
                                </li>
                            </ol>
                            <h2 class="h5">{{ $t('views.onboarding.get_started') }}</h2>
                            <p class="p">{{ $t('views.onboarding.instruction') }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                        <OnboardingOptions />
                    </div>
                </div>
            </div>
        </div>
    </AccountViewBase>
</template>

<script>
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import OnboardingOptions from '@/components/account/onboarding/OnboardingOptions';

    export default {
        name: 'OnboardingView',
        components: {
            AccountViewBase,
            OnboardingOptions
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.onboarding.seo_title',
            };
        }
    }
</script>
